import { useEffect } from "react";

export default function TawkChat() {
  useEffect(() => {
    // avoid injecting twice if React hot reloads
    if (document.getElementById("tawk-script")) return;

    // this part is basically your original snippet
    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];

    s1.async = true;
    s1.src = "https://embed.tawk.to/690339f261cd7f1952324e4b/1j8q9knlo";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s1.id = "tawk-script";

    s0.parentNode.insertBefore(s1, s0);

    // optional: expose API like in the snippet
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
  }, []);

  // this component doesn't render anything visible
  return null;
}
